import { loadImages, autoLoadComponents } from '@/js/utils/auto-loader.js';
import '@/js/lib/scroll.js';
import '@/js/lib/hero-reveal.js';
import '@/js/lib/hero-parallax.js';
import '@/js/lib/anchor-scroll.js';
import '@/js/lib/color-sets.js';
import '@/js/lib/highlight-reveal.js';
import '@/js/lib/pixel-grid.js';
import '@/js/lib/momentum-hover.js';
import '@/js/lib/vacature-sticky.js';
import '@/js/lib/hero-vacature-pin.js';
import '@/js/lib/archive-vacature.js';

// Initialize shared loaders
const images = loadImages();

import '@/css/main.scss';

const components = autoLoadComponents();

// Block labels (only active when logged in)
import '@/js/block-labels.js';
